import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FireplaceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fireplace"}/>
}
